import { EAircraftStatus, EMaoMaintenanceBadge, ESeverity } from '#shared';

import { getAircraftStatus, getAircraftTimeSeverity } from '../../helpers';

import type { AircraftData } from '#entities';

export type CrewAvailabilityGroup = 'NA' | ESeverity; // 'NA', 'CRITICAL', 'MAJOR', 'LOW'

export const headerTextMap: Record<CrewAvailabilityGroup, string> = {
  NA: 'N/A',
  CRITICAL: '<4h',
  MAJOR: '4-8h',
  MINOR: '6-8h',
  LOW: '8+h',
};

export const sortByOrder = (aircrafts: AircraftData[]): AircraftData[] =>
  aircrafts
    .reduce<AircraftData[][]>(
      (
        [
          available,
          onTrip,
          offDuty,
          unavailable,
          cleaning,
          scheduledMaint,
          aog,
        ],
        item,
      ) => {
        switch (getAircraftStatus(item)) {
          case EAircraftStatus.Available:
            available.push(item);
            break;
          case EAircraftStatus.OnTrip:
            onTrip.push(item);
            break;
          case EAircraftStatus.NotAvailable:
            offDuty.push(item);
            break;
          case EAircraftStatus.Maintenance:
            if (
              item.maintenanceType?.OpsBoardBadge === EMaoMaintenanceBadge.AOG
            ) {
              aog.push(item);
            } else if (
              item.maintenanceType?.OpsBoardBadge === EMaoMaintenanceBadge.CLN
            ) {
              cleaning.push(item);
            } else {
              scheduledMaint.push(item);
            }
            break;
          default:
            break;
        }
        return [
          available,
          onTrip,
          offDuty,
          unavailable,
          cleaning,
          scheduledMaint,
          aog,
        ];
      },
      [[], [], [], [], [], [], []],
    )
    .flat();

/** Group into NA / CRITICAL / MAJOR / LOW / MINOR */
export const groupByAvailability = (aircraftsSorted: AircraftData[]) => {
  const groups: Record<CrewAvailabilityGroup, AircraftData[]> = {
    NA: [],
    CRITICAL: [],
    MAJOR: [],
    LOW: [],
    MINOR: [],
  };

  for (const a of aircraftsSorted) {
    const sev = getAircraftTimeSeverity(a);
    const isMaint = getAircraftStatus(a) === EAircraftStatus.Maintenance;

    if (sev === ESeverity.NA || isMaint) {
      groups.NA.push(a);
    } else if (sev === ESeverity.CRITICAL) {
      groups.CRITICAL.push(a);
    } else if (sev === ESeverity.MAJOR) {
      groups.MAJOR.push(a);
    } else if (sev === ESeverity.LOW) {
      groups.LOW.push(a);
    }
  }
  return groups;
};
